module.exports = {"tax-account-connect-success":{"content":{"infor-1":"Bạn đã kết nối với Cơ quan Thuế thành công!","infor-2":"Bạn nhận được gói cước","infor-3":"phát hành 100 hóa đơn miễn phí","package":"EINVOICE_FREE100"},"actions":{"submit":"Thông báo phát hành ngay","cancel":"Tiếp tục sử dụng"}},"publish-invoice-info-modal":{"content":{"infor-1":"Bạn chưa lập thông báo hóa đơn với Tổng cục Thuế"},"actions":{"submit":"Thông báo phát hành ngay","cancel":"Tiếp tục sử dụng"}},"tours":{"create-invoice":{"title":"Hiện giờ bạn đã có thể phát hành hóa đơn trên Pinance!"}},"continue":"Hủy","ok":"ok"}


//////////////////
// WEBPACK FOOTER
// ./src/locale/vi/dialog.json
// module id = z2ko
// module chunks = 23